export default __webpack_public_path__ + "static/media/BMON.0a649170.svg";